'use strict';

var autoFitTotalPriceElementsObserver = null;

/**
 * Auto fit total price elements to parent container width
 * @param {jQuery} $parentElement - Parent element containing price elements
 * @param {Object} config - Initial config
 */
function autoFitTotalPriceElements($parentElement, config) {
    const precision = 0.25;
    var elementProperties = {
        minFontSize: config?.minFontSize || 20,
        childNodeSelectors: config?.childNodeSelectors || [],
        lastWidth: null
    };

    if (autoFitTotalPriceElementsObserver && typeof autoFitTotalPriceElementsObserver.destroy === 'function') {
        autoFitTotalPriceElementsObserver.destroy();
        autoFitTotalPriceElementsObserver = null;
    }

    /**
     * Get maximum font size from element
     * @param {HTMLElement} element - The element to get font size from
     * @returns {number} Maximum font size in pixels
     */
    function getMaxFontSize(element) {
        return parseFloat($(element).css('font-size'));
    }

    /**
     * Get render font size that fits element width
     * @param {HTMLElement} element - The element to fit
     * @param {number} maxFontSize - Maximum font size to start with
     * @param {boolean} applyToSelectedChildren - Indicates if the font-size change should be applied to children or not
     * @returns {number} Calculated font size in pixels
     */
    function getRenderFontSize(element, maxFontSize, applyToSelectedChildren) {
        var $priceValueElement = applyToSelectedChildren
            ? $(element).find(elementProperties.childNodeSelectors[1])
            : $(element).children();
        var fontSize = maxFontSize;

        if ($priceValueElement.length > 0) {
            $priceValueElement.css('font-size', `${fontSize}px`);

            if (element.scrollWidth > element.clientWidth) {
                while (fontSize - precision >= elementProperties.minFontSize) {
                    fontSize -= precision;
                    $priceValueElement.css('font-size', `${fontSize}px`);

                    if (element.scrollWidth <= element.clientWidth) {
                        break;
                    }
                }
            }
        }

        return fontSize;
    }

    /**
     * Apply calculated font size to all price elements
     */
    function applyFontSize() {
        $parentElement.each(function () {
            var $currentParentElement = $(this);
            var sharedFontSize = Infinity;
            var $elements = $currentParentElement.find(elementProperties.childNodeSelectors[0]);

            $elements.css('font-size', '');

            $elements.each(function () {
                var maxFontSize = getMaxFontSize(this);
                var renderFontSize =
                    elementProperties.childNodeSelectors.length > 1
                        ? getRenderFontSize(this, maxFontSize, true)
                        : getRenderFontSize($currentParentElement.children().first()[0], maxFontSize, false);
                sharedFontSize = Math.min(sharedFontSize, renderFontSize);
            });

            if (sharedFontSize !== Infinity) {
                $elements.css('font-size', `${sharedFontSize}px`);
                if (elementProperties.childNodeSelectors.length > 1) {
                    $elements.find(elementProperties.childNodeSelectors[1]).css('font-size', `${sharedFontSize}px`);
                }
            }
        });
    }

    applyFontSize();

    const resizeObserver = new ResizeObserver((entries) => {
        const rect = entries[0].contentRect;
        const width = rect.width;

        if (!elementProperties.lastWidth) {
            elementProperties.lastWidth = width;
        }

        if (width === elementProperties.lastWidth) return;

        elementProperties.lastWidth = width;

        requestAnimationFrame(applyFontSize);
    });

    $parentElement.each(function () {
        resizeObserver.observe(this);
    });

    autoFitTotalPriceElementsObserver = {
        destroy() {
            resizeObserver.disconnect();
        }
    };
}

/**
 * Initializes autoFitTotalPriceElements() function for cart total price elements
 */
function initializeAutoFitCartTotalPriceElements() {
    var $priceTotalElementCart = $('.line-item-total-price-container:has(.strike-through:not(.non-adjusted-price))');

    if ($priceTotalElementCart.length && $priceTotalElementCart.parent()) {
        autoFitTotalPriceElements($priceTotalElementCart.parent(), {
            minFontSize: 10,
            childNodeSelectors: ['.line-item-total-price-container >div']
        });
    }
}

module.exports = {
    productDetailDiscountPrice() {
        $('body').on('product:afterAttributeSelect', function () {
            var $priceTotalElementPPP = $(
                '.product-detail__info-controls.card:has([name="purchaseType"]:checked, ' +
                    '.purchase-label) .product-total-price'
            );

            if ($priceTotalElementPPP.length && $priceTotalElementPPP.find('del .list').length > 0) {
                autoFitTotalPriceElements($priceTotalElementPPP, {
                    minFontSize: 20,
                    childNodeSelectors: ['.price >span > *', 'span.value']
                });
            }
        });
    },
    cartDiscountPrice() {
        initializeAutoFitCartTotalPriceElements();

        $('body').on('cart:update minicart:show', function () {
            initializeAutoFitCartTotalPriceElements();
        });
    }
};
